import React from 'react';
import './VisionSection.css';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const VisionSection: React.FC = () => {
  const { ref: sectionRef, style: sectionStyle } = useScrollAnimation<HTMLElement>({ delay: 0.1 });
  const { ref: labelRef, style: labelStyle } = useScrollAnimation<HTMLSpanElement>({ delay: 0.2 });
  const { ref: titleRef, style: titleStyle } = useScrollAnimation<HTMLHeadingElement>({ delay: 0.3 });
  const { ref: block1Ref, style: block1Style } = useScrollAnimation<HTMLDivElement>({ delay: 0.4 });
  const { ref: block2Ref, style: block2Style } = useScrollAnimation<HTMLDivElement>({ delay: 0.5 });
  const { ref: block3Ref, style: block3Style } = useScrollAnimation<HTMLDivElement>({ delay: 0.6 });

  return (
    <section className="vision-section" id="vision" ref={sectionRef} style={sectionStyle}>
      <div className="vision-container">
        <div className="vision-content">
          <span className="section-label" ref={labelRef} style={labelStyle}>The Vision</span>
          <h2 className="vision-title" ref={titleRef} style={titleStyle}>
            Building <span className="highlight">Something Real</span>
          </h2>
          
          <div className="vision-blocks">
            <div className="vision-block" ref={block1Ref} style={block1Style}>
              <div className="block-number">01</div>
              <div className="block-content">
                <h3>Secret Tech in Development</h3>
                <p>
                  I have plans for new tech — it's such a strong idea that if I truly disclose 
                  this information it will be used for no good. I want to develop tools to help 
                  with coins, and with the help of the community, I can make this much easier 
                  than it ever will be.
                </p>
              </div>
            </div>

            <div className="vision-block" ref={block2Ref} style={block2Style}>
              <div className="block-number">02</div>
              <div className="block-content">
                <h3>Real Talk</h3>
                <p>
                  I've been in the trenches long enough for me not to say something stupid like 
                  "I will save the trenches" — but I want to do at least some serious damage and 
                  help some people truly achieve some wealth and health while we all benefit.
                </p>
              </div>
            </div>

            <div className="vision-block" ref={block3Ref} style={block3Style}>
              <div className="block-number">03</div>
              <div className="block-content">
                <h3>The Question</h3>
                <p>
                  Are my good intentions going to be enough to pave the way? Who knows!
                </p>
                <p className="highlight-quote">
                  But together we can make it happen.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VisionSection;